module.exports = __webpack_public_path__ + "static/img/profile_banner.da0b738b.webp";